/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Advantage from 'parts/Advantage';
import OurClients from 'parts/OurClients';
import Testimonial from 'parts/Testimonial';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

import Data from 'json/landingPage.json';

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const processSteps = [
      {
        title: 'Discover',
        subtitle: 'Initial Phase',
        description: 'We begin with assigning a dedicated POC to the client who understands the needs of the client. Once we have the assurance that both of us are on the same page, the work begins.',
        icon: '🔍',
      },
      {
        title: 'Develop',
        subtitle: 'Development Phase',
        description: 'The project begins with the analysis phase where we breakdown the entire project into simple tasks/tickets and assign a dedicated resource on it. Once the assignment is complete, development begins. We share a dedicated dashboard with you to track continuous progress of the project. You can monitor the changes, improvements and work done on your project in real-time. We encourage feedback from our clients on a consistent basis to incorporate any suggestions.',
        icon: '💻',
      },
      {
        title: 'Test',
        subtitle: 'Testing Phase',
        description: 'From the development phase each task then moves to the testing phase. It is one of our most stringent processes. All our projects are tested in three stages. In the first stage, it is the integration testing, where we do a peer review. After the review, it enters the second stage, where we do a code review. In the last stage, we do a QA testing where it is at the option of the client to get it done in-house by us or at their site. If any failure is discovered at any testing phase, the task/ticket returns to the development phase. Only upon passing all the three test phases, the task is assured as complete.',
        icon: '✅',
      },
      {
        title: 'Deliver',
        subtitle: 'Satisfaction',
        description: 'Once we have assured your 100% satisfaction, we handover your dream project to you. Even after the delivery if you feel you need some help, we provide 3 months of free maintenance. Reach out to us for any help, we are just a click away!',
        icon: '🚀',
      },
    ];

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                About Us
              </h1>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                Who We Are?
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-4xl mx-auto leading-relaxed">
                At ERapid, we all come to work every day because we believe in the power of
                technology. We help people build great businesses with the help of intelligent
                technological solutions. We know how difficult it can be to understand technology
                just like it would be difficult for us to comprehend medical analogies. Therefore,
                being the tech drivers that we are, we love to simplify the complexities for our
                clients and understand their requirements. We love taking new challenges and
                pushing ourselves to build exactly what you have in mind. You have an idea, we
                have a solution!
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                Core Team
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                We are a team of passionate techies who love their code. A community of proactive,
                lively, and seasoned professionals. If you happen to drop by our office, you will
                see us building awesome digital products, brainstorming over bugs, and bringing
                innovative ideas to life!
              </p>
            </Fade>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
              {Data.team.slice(0, 12).map((member, index) => (
                <Fade bottom delay={100 * index} key={member.name}>
                  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-4 transform transition-all duration-300 hover:shadow-xl hover:scale-105 text-center">
                    <div className="w-20 h-20 mx-auto mb-3 rounded-full overflow-hidden bg-gradient-to-br from-theme-purple/10 to-dark-theme-purple/10 flex items-center justify-center">
                      <img src={member.imageUrl} alt={member.name} className="w-full h-full object-cover" />
                    </div>
                    <h3 className="text-sm font-semibold text-theme-blue mb-1">{member.name}</h3>
                    <p className="text-xs text-gray-600">{member.position}</p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h2 className="text-4xl lg:text-5xl text-theme-blue text-center font-bold mb-4">
                Process
              </h2>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                At ERapid, we work through an organized &apos;bit-by-bit&apos; process.
              </p>
            </Fade>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {processSteps.map((step, index) => (
                <Fade bottom delay={200 * index} key={step.title}>
                  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 h-full">
                    <div className="text-5xl mb-4 text-center">{step.icon}</div>
                    <h3 className="text-2xl font-bold text-theme-blue mb-2 text-center">{step.title}</h3>
                    <p className="text-sm font-semibold text-theme-purple mb-4 text-center">{step.subtitle}</p>
                    <p className="text-sm text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        <Advantage data={Data.advantage} />
        <OurClients data={Data.clients} />
        <Testimonial data={Data.testimonial} />
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
